import { styled, Box } from "@mui/material";

export const TodayIconWrapper = styled(Box)({
    width: 70,
    height: 70,
    backgroundSize: "contain",
    backgroundRepeat: "no-repeat",
    backgroundPosition: "center",
});